import { getParamNames } from './PatternUtils';

/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  getParamNames(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

export default getRouteParams;


//////////////////
// WEBPACK FOOTER
// ./~/react-router/es6/getRouteParams.js
// module id = 426
// module chunks = 7